/**
 * resolveTenantBranding — 업로드 로고 우선, 없으면 정적 TENANT_BRANDING
 */
import { loadTenantLogo } from 'system/tenantLogoStore';

export const DEFAULT_LOGIN_TAGLINE = '전사적자원관리 토탈 솔루션';

/** @type {Record<string, { logoUrl: string, logoAlt: string, logoAreaDark?: boolean }>} */
export const TENANT_BRANDING = {
  GNK: {
    logoUrl: '/logos/gnk-ci.png',
    logoAlt: '굿네이버스',
    logoAreaDark: false,
  },
};

/**
 * @param {string} compCd
 * @returns {{ logoUrl: string, logoAlt: string, logoAreaDark?: boolean, source?: 'upload'|'static' } | null}
 */
export function resolveTenantBranding(compCd) {
  const code = String(compCd || '').trim().toUpperCase();
  if (!code) return null;

  const uploaded = loadTenantLogo(code);
  if (uploaded?.logoDataUrl) {
    return {
      logoUrl: uploaded.logoDataUrl,
      logoAlt: uploaded.logoAlt || code,
      logoAreaDark: uploaded.logoAreaDark === true,
      source: 'upload',
    };
  }

  const entry = TENANT_BRANDING[code];
  if (!entry?.logoUrl) return null;
  const base = process.env.PUBLIC_URL || '';
  const path = entry.logoUrl.startsWith('/') ? entry.logoUrl : `/${entry.logoUrl}`;
  return {
    ...entry,
    logoUrl: `${base}${path}`,
    source: 'static',
  };
}
